<template>
  <div class="order-confrim">
    <close @close="goabck" title="订单确认"></close>

    <!-- 商品 -->
    <div class="order-goods">
      <div class="goods-intro">
        <div class="goods-img van-hairline--surround">
          <img v-lazy="currentSku.pic_url" />
        </div>
        <div class="goods-desc">
          <div class="goods-name van-multi-ellipsis--l2">
            {{ currentSku.name }}
          </div>
          <div :key="index" class="user-phone" v-for="(fling, index) in flings">
            {{ fling.title }}: {{ fling.accounts }}
          </div>
          <div class="goods-price">¥{{ skuPrice }}</div>
        </div>
      </div>
    </div>
    <!-- 优惠券使用福利金抵扣 -->
    <div class="discount-choose">
      <div class="shopping-gold-wrapper">
        <div class="user-shopping-gold">
          <span>使用福利金</span>
          <span>福利金余额：{{ userGoldInfo.account }}</span>
        </div>
        <div class="shopping-gold-check-status">
          <van-switch
            :disabled="shoppingGoldCheckDisabled"
            :value="goldCheckStatus"
            @input="switchHandler"
            class="gold-switch"
            inactive-color="#ccc"
            size="15px"
          ></van-switch>
          <span v-show="goldCheckStatus">
            抵扣：
            <em class="normal-price-c">¥{{ discountPrice }}</em>
          </span>
        </div>
      </div>
    </div>
    <!-- 商品简介 -->
    <div class="order-intro">
      <div class="order-price van-hairline--bottom">
        <span class="title">实付金额</span>
        <span class="price">¥{{ payPrice }}</span>
      </div>
      <div class="order-options">
        <div class="option">
          <span class="title">商品金额</span>
          <span>¥{{ currentSku.market_price }}</span>
        </div>
        <div class="shopping-gold-discount option" v-show="memberDiscount">
          <span class="title">会员优惠</span>
          <span>- ¥{{ memberDiscount }}</span>
        </div>
        <div class="shopping-gold-discount option">
          <span class="title">福利金抵扣</span>
          <span>- ¥{{ discountPrice }}</span>
        </div>
      </div>
    </div>

    <!-- 开通会员提示 -->
    <div class="open-member" v-if="memberInfo">
      <div class="member-intro">
        <p>立即开通{{ memberInfo.name }}</p>
        <p v-show="priceDifference * 1">
          本次订单可为您节省
          <em>{{ priceDifference }}</em> 元
        </p>
      </div>
      <button @click="$router.push({ name: 'memberCenter' })">去开通</button>
    </div>

    <!-- 底部导航 -->
    <div class="shoping-trolley-footer van-hairline--top">
      <div class="product-total-price">
        <div class="total-price">
          <div class="total">
            <span>实付:</span>
            <div class="price">
              ¥
              <em>{{ payPrice }}</em>
            </div>
          </div>
          <div class="shop-wealfare" v-show="rebatePrice * 1">
            共返 {{ rebatePrice }} 福利金
          </div>
        </div>
        <div class="settle-accounts">
          <button @click="settleAccounts" class="submit">去结算</button>
        </div>
      </div>
    </div>
    <user-dialog
      :show="dialog.show"
      @cancel-handler="cancelHandler"
      @confrim-handler="confrimHandler"
    >
      <template #msg>{{ dialog.text }}</template>
    </user-dialog>
  </div>
</template>

<script>
import { Switch } from 'vant'
import Close from '../components/Close'
import UserDialog from '../components/Dialog'
import Big from 'big.js'
const init = new Big(0)
// let flag = false
export default {
  name: 'orderConfrim',
  components: {
    'VanSwitch': Switch,
    Close,
    UserDialog
  },
  data () {
    return {
      oid: null,
      orderDetails: {},
      flings: {},
      currentSku: {
        market_price: 0
      },
      userGoldInfo: {
        account: 0
      },
      dialog: {
        show: false,
        text: '选了这么久, 确认要退出么?'
      },
      memberInfo: false,
      goldCheckStatus: false,
      orderPrice: {
        discount: '0.00',
        rebate: '0.00'
      }
    }
  },
  computed: {
    shoppingGoldCheckDisabled () {
      return !(this.userGoldInfo && this.userGoldInfo.account * 1 > 0)
    },
    skuPrice () {
      return this.orderPrice.discount
    },
    rebatePrice () {
      return this.orderPrice.rebate
    },
    goldNum () {
      return (this.userGoldInfo && this.userGoldInfo.account * 1) || 0
    },
    goldPaystatus () {
      return init.plus(this.goldNum).minus(this.skuPrice) > 0
    },
    discountPrice () {
      if (this.goldCheckStatus) {
        return this.goldPaystatus ? this.skuPrice : this.goldNum
      } else {
        return '0.00'
      }
    },
    memberDiscount () {
      const price = init.plus(this.currentSku.market_price).minus(this.orderPrice.discount)
      return price > 0 ? price : false
    },
    payPrice () {
      if (this.goldCheckStatus) {
        return this.goldPaystatus ? '0.00' : init.plus(this.orderPrice.discount).minus(this.goldNum)
      } else {
        return this.orderPrice.discount
      }
    }
  },
  created () {
    this.oid = this.$route.query.oid
    this.getOrderDetails()
  },
  methods: {
    async updateOrderDetails (params) {
      const res = await this.$axios.post('api/order/uto', { type: 'rec', data: { id: this.oid, ...params } })
      if (res.status === 200) {
        const { code, msg } = res.data
        if (code === 0) {
        } else {
          this.$toast(msg)
        }
      }
    },
    // 获取订单详情
    async getOrderDetails () {
      const res = await this.$axios.post('api/order/gto', { type: 'rec', data: { id: this.oid } })
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.orderDetails = data
          this.goldCheckStatus = data.order.sa
          this.flings = data.order.filling
          this.currentSku = data.order.sku
          this.userGoldInfo = data.account
          this.orderPrice = data.order.price
        } else {
          this.$toast(msg)
        }
      }
    },

    // 勾选福利金
    switchHandler () {
      this.goldCheckStatus = !this.goldCheckStatus
      this.updateOrderDetails({ sa: this.goldCheckStatus })
    },

    // 提交订单
    async settleAccounts () {
      this.$toast.loading('正在提交订单...')
      const res = await this.$axios.post('api/order/cto', { type: 'rec', data: { id: this.oid } })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          this.pay(data)
          // location.href = data
        } else if (code === 100) {
          this.$toast('下单成功')
          setTimeout(() => {
            this.$router.replace({ name: 'orderDetails', query: { orderid: data } })
          }, 500)
        } else {
          this.$toast(msg)
        }
      }
    },

    // 拉起支付
    async pay (id) {
      this.$toast.loading('下单成功,正在为您拉起支付')
      const res = await this.$axios.post('api/pay/order', { id })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, msg, data } = res.data
        if (code === 0) {
          location.href = data.redirect
        } else {
          this.$toast(msg)
        }
      }
    },

    // 返回上一级
    goabck () {
      this.dialog.show = true
    },

    //  弹窗 取消
    cancelHandler () {
      this.dialog.show = false
    },

    //  弹窗确认
    confrimHandler () {
      this.$router.back()
      this.dialog.show = false
    },

    //  选中开通会员
    dredgeMember ({ checkStatus }) {
      this.dredgeMemberStatus = checkStatus
    }

  }

}
</script>

<style lang="less" scoped>
.order-goods {
  .goods-intro {
    padding: 0.3rem;
    background-color: #fff;
    .flex-between;
    justify-content: flex-start;
    .goods-img {
      width: 1.5rem;
      height: 1.5rem;
    }
    .goods-desc {
      padding-left: 0.25rem;
      max-width: 5rem;
      .flex-column-between;
    }
    .goods-name {
      font-size: 0.28rem;
      color: @base;
    }
    .user-phone {
      color: #969696;
      font-size: @fz24;
      padding: 0.15rem 0;
    }
    .goods-price {
      color: #ff6060;
      font-size: @fz24;
    }
  }
}
.order-intro {
  background-color: #fff;
  .order-price {
    height: 0.84rem;
    padding: 0 0.3rem;
    .flex-between;
    font-size: 0.3rem;
    font-weight: bold;
    .title {
      color: @base;
    }
    .price {
      color: #ff3434;
    }
  }
  .order-options {
    padding: 0.15rem 0.3rem 0;
    font-size: @fz24;
    color: #bababa;
    .option {
      .flex-between;
      padding-bottom: 0.27rem;
    }
    .title {
      width: 1.2rem;
      text-align: right;
    }
  }
}
.discount-choose {
  font-size: @fz24;
  color: @base;
  background-color: #fff;
  margin: 0.2rem 0;
  .shopping-gold-wrapper {
    padding: 0.2rem 0.3rem;
    height: 0.95rem;
    .flex-between;
    .user-shopping-gold {
      height: 100%;
      .flex-column-between;
      span:nth-chil(1) {
        font-size: @fz28;
        font-weight: bold;
      }
      span:nth-child(2) {
        color: @c80;
      }
    }
    .shopping-gold-check-status {
      // width: 1rem;
      height: 100%;
      .flex-column-between;
      align-items: flex-end;
    }
  }
}
.open-member {
  position: relative;
  width: 6.9rem;
  height: 1.55rem;
  margin: 0.58rem auto 0;
  background: linear-gradient(
    180deg,
    rgba(30, 62, 117, 1) 0%,
    rgba(18, 33, 57, 1) 100%
  );
  border-radius: 0.1rem;
  font-size: @fz28;
  font-weight: 660;
  color: #fff;
  .flex-between;
  margin-bottom: 0.4rem;
  .member-intro {
    display: flex;
    flex-direction: column;
    p {
      padding-left: 0.32rem;
      em {
        color: #ff9600;
      }
    }
  }
  button {
    margin-right: 0.26rem;
    width: 1.96rem;
    height: 0.78rem;
    background-color: #f1c40f;
    border-radius: 30px;
    font-size: 0.32rem;
    color: #b53900;
  }
}
.shoping-trolley-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  height: 1.2rem;
  .flex-between;
  font-size: @fz28;
  .product-total-price {
    .flex-between;
    width: 100%;
    height: 100%;
    .total-price {
      padding-left: 0.35rem;
      .flex-center;
    }
    .total {
      color: @base;
      font-size: @fz34;
      display: flex;
      font-weight: 660;
      span {
        padding-right: 0.23rem;
      }
      .price {
        color: #ff3737;
      }
    }
    .shop-wealfare {
      margin-left: 0.23rem;
      padding: 0.05rem 0.2rem;
      background-color: #ffe6e6;
      border-radius: 30px;
      font-size: @fz20;
      color: #e93b3b;
    }
  }
  .settle-accounts {
    width: 1.72rem;
    height: 100%;
    color: #fff;
    button {
      width: 100%;
      height: 100%;
      background-color: #ff3824;
      &:disabled {
        background-color: #333;
      }
    }
    .cannot-submit {
      background-color: #333;
    }
  }
}
</style>
